export default "__VITE_ASSET__6RH0v2Jn__"